var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66245 11.9167H6.60828C5.8654 11.911 5.13111 11.7572 4.44842 11.4642C3.76573 11.1712 3.14835 10.745 2.63245 10.2104C1.67578 9.18735 1.13197 7.8462 1.10596 6.44578C1.07995 5.04536 1.57359 3.68494 2.49161 2.62707C3.08305 1.96426 3.82657 1.45495 4.65828 1.1429C4.75533 1.10556 4.86107 1.09694 4.96288 1.11807C5.0647 1.1392 5.15828 1.18919 5.23245 1.26207C5.30114 1.33212 5.34952 1.41951 5.37241 1.51491C5.39531 1.61031 5.39186 1.71014 5.36245 1.80374C5.06559 2.61674 5.00678 3.49755 5.1929 4.34281C5.37903 5.18807 5.80239 5.9627 6.41328 6.57582C7.02987 7.18484 7.80635 7.60676 8.65281 7.79273C9.49928 7.9787 10.3811 7.92112 11.1962 7.62665C11.2932 7.5925 11.3979 7.58668 11.4982 7.60986C11.5984 7.63305 11.6899 7.68428 11.762 7.75758C11.8342 7.83087 11.884 7.92319 11.9056 8.02375C11.9272 8.1243 11.9198 8.22893 11.8841 8.3254C11.6074 9.06408 11.1751 9.73465 10.6166 10.2917C10.0971 10.8096 9.48028 11.2199 8.80169 11.4987C8.1231 11.7776 7.3961 11.9196 6.66245 11.9167Z",
    fill: "#AABCCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.4c68ce31.svg";
export { ForwardRef as ReactComponent };